'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Export javascript style and css style vendor prefixes.
 * Based on "transform" support test.
 */

var js = '';
var css = '';

// We should not do anything if required serverside.
if (typeof document != 'undefined') {
  var jsCssMap = {
    Webkit: '-webkit-',
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports.default = { js: js, css: css };


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-vendor/lib/prefix.js
 ** module id = 58
 ** module chunks = 0
 **/